import { render, staticRenderFns } from "./CommentContentLayout.vue?vue&type=template&id=6919ceb8&scoped=true&"
import script from "./CommentContentLayout.vue?vue&type=script&lang=js&"
export * from "./CommentContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommentContentLayout.vue?vue&type=style&index=0&id=6919ceb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6919ceb8",
  null
  
)

export default component.exports